<div
    *transloco="let t"
    [class]="
        'bazis-control bazis-vehicle-number-control bazis-vehicle-number-control_' +
        regionSuffix +
        cssClassSizeControl
    "
    [ngClass]="{
        'bazis-control--invalid': ngControl.control.invalid,
        'bazis-control--disabled': isDisabled,
        'bazis-control--focused': isFocused,
        'bazis-control--empty': emptyValues.indexOf(ngControl.control.value) > -1,
        'bazis-control--dirty': ngControl.control.touched && !isFocused,
    }"
>
    <ng-container
        *ngIf="{
            required: required$ | async,
            clrPartValues: clrPartValues$ | async,
        } as data"
    >
        <bazis-label
            [isMajor]="hasTitleMajor"
            [isEmptyLabel]="isEmptyLabel"
            [title]="title || t(titleKey, titleParams)"
            [required]="data.required"
        >
            <bazis-interrogation
                *ngIf="tooltipKey"
                [slot]="tooltipSettings?.targetSide"
                iconSize="compact"
                [tooltipText]="t(tooltipKey, tooltipParams)"
                [tooltipOffset]="[-8, 4]"
                [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                [icon]="icons.interrogation"
                [type]="interrogationType"
            ></bazis-interrogation>
        </bazis-label>

        <div
            class="bazis-control__field-group"
            [class.bazis-control__field-group--disabled]="isDisabled"
            [class.bazis-control__field-group--focused]="isFocused"
        >
            <span
                *ngFor="let part of parts; let i = index"
                class="bazis-control__field"
                [ngClass]="['bazis-vehicle-number-control__part_' + i]"
            >
                <!-- (focus)="markAsTouched()" -->
                <input
                    #vehicleInput
                    (focus)="focusField($event)"
                    (blur)="blurField($event)"
                    [formControl]="part.control"
                    (keydown.backspace)="onPressBackspace(i)"
                    (keydown.arrowLeft)="onPressArrowLeft($event, i)"
                    (keydown.arrowRight)="onPressArrowRight($event, i)"
                    [mask]="part.maskSettings.mask"
                    [patterns]="part.maskSettings.patterns"
                    [showMaskTyped]="part.maskSettings.showMaskTyped"
                    [placeHolderCharacter]="part.maskSettings.placeHolderCharacter"
                    [shownMaskExpression]="part.maskSettings.shownMaskExpression"
                    [keepCharacterPositions]="part.maskSettings.keepCharacterPositions"
                    [triggerOnMaskChange]="part.maskSettings.triggerOnMaskChange"
                    [inputTransformFn]="part.maskSettings.inputTransformFn"
                    [outputTransformFn]="part.maskSettings.outputTransformFn"
                />
                <input
                    *ngIf="!data.clrPartValues || data.clrPartValues[i] === ''"
                    type="text"
                    tabindex="-1"
                    class="bazis-vehicle-number-control__placeholder"
                    [placeholder]="part.placeholder"
                />
            </span>
        </div>
        <ng-container *ngIf="{ change: change$ | async } as clrData"></ng-container>

        <div class="bazis-control__error">
            <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
            <ng-content></ng-content>
        </div>

        <div
            *ngIf="noteKey"
            class="bazis-control__note"
        >
            {{ t(noteKey, noteParams) }}
        </div>
    </ng-container>
</div>
